import { render } from "./JobNotStartedIcon.vue?vue&type=template&id=4e6872b2"
import script from "./JobNotStartedIcon.vue?vue&type=script&lang=js"
export * from "./JobNotStartedIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__